import AddPartner from '../../../settings/components/AddPartner';

const AddPartnerPage = () => {
    return <AddPartner />;
};

export default AddPartnerPage;
